import React, { useState } from 'react';
import { Modal, Button, Table, Form, Row, Col } from 'react-bootstrap';
import { useCart } from './CartContext';
import { FaShoppingCart, FaTrash } from 'react-icons/fa'; // Importa los iconos de carrito y eliminar

import { db } from './Authfirebase';
import { collection, addDoc } from 'firebase/firestore';

const CartModal = ({ show, handleClose }) => {
    const { cart, removeFromCart, clearCart, updateQuantity } = useCart();
    const [showCheckoutForm, setShowCheckoutForm] = useState(false);
    const [formData, setFormData] = useState({
        colonia: '',
        direccion: '',
        telefono: ''
    });
    const [errors, setErrors] = useState({});

    // Calcular el total del carrito
    const calculateTotal = () => {
        return cart.reduce((total, item) => total + item.price * item.quantity, 0);
    };

    // Calcular el total real del carrito
    const calculateOriginalTotal = () => {
        return cart.reduce((total, item) => total + item.originalPrice * item.quantity, 0);
    };

    const handleCheckout = () => {
        setShowCheckoutForm(true);
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        setErrors({
            ...errors,
            [name]: ''
        });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.colonia) newErrors.colonia = 'La colonia es requerida';
        if (!formData.direccion) newErrors.direccion = 'La dirección es requerida';
        if (!formData.telefono) newErrors.telefono = 'El teléfono es requerido';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
    
        // Guardar los detalles del pedido en la colección "pedido"
        const pedidoRef = collection(db, 'pedido');
        const pedidoDocRef = await addDoc(pedidoRef, {
            items: cart,
            total: calculateTotal(),
            timestamp: new Date(),
            estado: 'pendiente' // Establecer el estado inicial como "pendiente"
        });
    
        // Guardar los datos de la dirección en la colección "direccionPedido"
        const direccionPedidoRef = collection(db, 'direccionPedido');
        await addDoc(direccionPedidoRef, {
            pedidoId: pedidoDocRef.id,
            colonia: formData.colonia,
            direccion: formData.direccion,
            telefono: formData.telefono,
            timestamp: new Date()
        });
    
        // Aquí puedes manejar el envío del formulario, por ejemplo, enviar los datos al servidor
        console.log('Datos de envío:', formData);
        // Cerrar el modal después de enviar el formulario
        handleClose();
    };
    
    return (
        <Modal show={show} onHide={handleClose} size="xl" dialogClassName="modal-fullscreen">
            <Modal.Header closeButton>
                <Modal.Title>Carrito de compras</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {cart.length === 0 ? (
                    <p>El carrito está vacío</p>
                ) : (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Producto</th>
                                <th>Precio Original</th>
                                <th>Precio con Descuento</th>
                                <th>Cantidad</th>
                                <th>Total</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cart.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>{item.nombre}</td>
                                    <td style={{ textDecoration: 'line-through', color: 'red' }}>
                                        ${item.originalPrice.toFixed(2)}
                                    </td>
                                    <td>${item.price.toFixed(2)}</td>
                                    <td>
                                        <Form.Control
                                            type="number"
                                            value={item.quantity}
                                            onChange={(e) => updateQuantity(item.id, parseInt(e.target.value))}
                                            min="1"
                                        />
                                    </td>
                                    <td>${(item.price * item.quantity).toFixed(2)}</td>
                                    <td>
                                        <Button variant="danger" size="sm" onClick={() => removeFromCart(item.id)}>
                                            <FaTrash />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
                {cart.length > 0 && (
                    <div>
                        <strong>
                            Total Real: <span style={{ textDecoration: 'line-through', color: 'red' }}>
                                ${calculateOriginalTotal().toFixed(2)}
                            </span>
                        </strong>
                        <br />
                        <strong>Total con Descuento: ${calculateTotal().toFixed(2)}</strong>
                    </div>
                )}
                {showCheckoutForm && (
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col>
                                <Form.Group controlId="colonia">
                                    <Form.Label>Colonia</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="colonia"
                                        value={formData.colonia}
                                        onChange={handleFormChange}
                                        required
                                    />
                                    {errors.colonia && <Form.Text className="text-danger">{errors.colonia}</Form.Text>}
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="direccion">
                                    <Form.Label>Dirección</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="direccion"
                                        value={formData.direccion}
                                        onChange={handleFormChange}
                                        required
                                    />
                                    {errors.direccion && <Form.Text className="text-danger">{errors.direccion}</Form.Text>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="telefono">
                                    <Form.Label>Teléfono</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="telefono"
                                        value={formData.telefono}
                                        onChange={handleFormChange}
                                        required
                                    />
                                    {errors.telefono && <Form.Text className="text-danger">{errors.telefono}</Form.Text>}
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="metodoPago">
                                    <Form.Label>Método de Pago</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value="Efectivo"
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Button variant="primary" type="submit" disabled={cart.length === 0}>
                            Enviar
                        </Button>
                    </Form>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
                <Button variant="danger" onClick={clearCart}>
                    Vaciar carrito
                </Button>
                {cart.length > 0 && !showCheckoutForm && (
                    <Button variant="success" onClick={handleCheckout}>
                        Comprar
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default CartModal;
